export const dummyTest = {
	clubDetails: {
		_id: "5fc8e1b3ca0c7edf35ac2e3b",
		email: "rajat.main06@gmail.com",
		name: "CodeChef-VIT",
		type: "technical",
	},
	testDetails: {
		_id: "5fc8fd42edf1d309c4f858ac",
		roundNumber: 1,
		roundType: "Written",
		instructions: "This is the first round of our recruitment process",
		scheduledForDate: 1606797000000,
		scheduledEndDate: 1607229000000,
		graded: true,
	},
	domainDetails: {
		_id: "5fc8fd72edf1d309c4f858ad",
		domainName: "Technical",
		domainDescription: "This is the tech domain",
		domainInstructions: "Answer all questions",
		domainDuration: 30,
		domainMarks: 26,
	},
	questions: [
		{
			questionId: "5fc90976e7c24a4af4d5e13a",
			questionType: "singleCorrect",
			questionMarks: 1,
			description: "Select the correct option",
			media: {
				ext: "png",
				mimetype: "image/png",
				type: "image",
				url:
					"https://cet-prod.s3.ap-south-1.amazonaws.com/media/question/1608374481943_Akshat%20Gupta.png",
			},
			options: [
				{
					optionId: "5fc90976e7c24a4af4d5e122",
					text: "Option One",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e123",
					text: "Option Two",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e124",
					text: "Option Three",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e125",
					text: "Option Four",
				},
			],
		},
		{
			questionId: "5fc90976e7c24a4af4d5e13b",
			questionType: "singleCorrect",
			questionMarks: 1,
			description: "This is an mcq with one correct answer",
			media: {
				ext: "quicktime",
				mimetype: "video/quicktime",
				type: "video",
				url:
					"https://cet-prod.s3.ap-south-1.amazonaws.com/media/question/1608409399109_Screen%20Recording%202020-12-20%20at%201.51.58%20AM.mov",
			},
			options: [
				{
					optionId: "5fc90976e7c24a4af4d5e126",
					text: "Option One",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e127",
					text: "Option Two",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e128",
					text: "Option Three",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e129",
					text: "Option Four",
				},
			],
		},
		{
			questionId: "5fc90976e7c24a4af4d5e13c",
			questionType: "singleCorrect",
			questionMarks: 1,
			description: "This is another mcq with one correct answer",
			options: [
				{
					optionId: "5fc90976e7c24a4af4d5e12a",
					text: "Option One",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e12b",
					text: "Option Two",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e12c",
					text: "Option Three",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e12d",
					text: "Option Four",
				},
			],
		},
		{
			questionId: "5fc90976e7c24a4af4d5e13d",
			questionType: "multipleCorrect",
			questionMarks: 1,
			description: "Select the correct optionsss",
			options: [
				{
					optionId: "5fc90976e7c24a4af4d5e12e",
					text: "Option One",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e12f",
					text: "Option Two",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e130",
					text: "Option Three",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e131",
					text: "Option Four",
				},
			],
		},
		{
			questionId: "5fc90976e7c24a4af4d5e13e",
			questionType: "multipleCorrect",
			questionMarks: 1,
			description: "This is an mcq with multiple correct answers",
			options: [
				{
					optionId: "5fc90976e7c24a4af4d5e132",
					text: "Option One",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e133",
					text: "Option Two",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e134",
					text: "Option Three",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e135",
					text: "Option Four",
				},
			],
		},
		{
			questionId: "5fc90976e7c24a4af4d5e13f",
			questionType: "multipleCorrect",
			questionMarks: 1,
			description: "This is another mcq with multiple correct answers",
			options: [
				{
					optionId: "5fc90976e7c24a4af4d5e136",
					text: "Option One",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e137",
					text: "Option Two",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e138",
					text: "Option Three",
				},
				{
					optionId: "5fc90976e7c24a4af4d5e139",
					text: "Option Four",
				},
			],
		},
		{
			questionId: "5fc90976e7c24a4af4d5e140",
			questionType: "shortAnswer",
			questionMarks: 5,
			description: "This is a short answer type question",
		},
		{
			questionId: "5fc90976e7c24a4af4d5e141",
			questionType: "shortAnswer",
			questionMarks: 5,
			description: "This is another short answer type question",
		},
		{
			questionId: "5fc90976e7c24a4af4d5e142",
			questionType: "longAnswer",
			questionMarks: 5,
			description: "This is a long answer type question",
		},
		{
			questionId: "5fc90976e7c24a4af4d5e143",
			questionType: "longAnswer",
			questionMarks: 5,
			description: "This is another long answer type question",
		},
	],
};
